/**
 * Used to lazy load <video> elements by adding "video-lazy-load" css class.
 * 
 * @example <video class="video-lazy-load">
 */
(function(){
    const videosElems = document.querySelectorAll('.video-lazy-load');
    if (!videosElems.length) return;
    // element must have a visibility threshold of 50%
    const lazyLoadObserver = new IntersectionObserver(function(entries, observer){
        entries.forEach(function(entry){
            if (!entry.isIntersecting) return;
            let videoElem = entry.target;
            videoElem.querySelectorAll('source[data-src]').forEach(function(sourceElem){
                sourceElem.src = sourceElem.dataset.src;
            });
            videoElem.load();
            lazyLoadObserver.unobserve(videoElem);
        });
    }, {threshold: 0.5});
    videosElems.forEach(function(videoElem){
        lazyLoadObserver.observe(videoElem);
    });
})();
